import { useStatic } from '~/common/hooks/useStatic';
import { Feature } from '../../../../types';
import { useFeatures } from '../useFeatures';

export const useFeature = (key: string): Feature => {
  const { getFeature } = useFeatures();
  const fallbackFeature = useStatic({
    enabled: false,
    key,
    name: '',
    options: {},
  } as Feature);

  return getFeature(key) || fallbackFeature;
};
